import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import InterestForm from './InterestForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class EditInterestModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.updateInterest( values.interestid, { ...values } )
        .then( ( category ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( category );
        } );
    }



    render() {
        const { category } = this.props;
        return (
            <DLModal title='Edit Interest'
            closeHandler={ this.props.closeModal }>
                <div>
                    <InterestForm onSubmit={ this.submitHandler } initialValues={ category } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateInterest: ( interestid, data ) => {
            return dAPI.patch( `/interests/${ interestid }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditInterestModal );
